import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { LIB_CONFIG, LibConfig } from '../../lib.config';

@Component({
  selector: 'now-wbsuche-lib-befragung-banner',
  templateUrl: './befragung-banner.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BefragungBannerComponent {
  libConfig = inject<LibConfig>(LIB_CONFIG);
}
